var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      directives: [
        {
          name: "scroll",
          rawName: "v-scroll",
          value: _vm.onScroll,
          expression: "onScroll",
        },
      ],
    },
    [
      _c("mini-header", {
        attrs: {
          title: "Información de la tienda",
          breadcrumbs: _vm.breadcrumbs,
          dense: true,
          hiddenTab: true,
          addPadding: true,
          scroll: _vm.scroll,
        },
        scopedSlots: _vm._u([
          {
            key: "main",
            fn: function () {
              return undefined
            },
            proxy: true,
          },
        ]),
      }),
      _vm.$store.state.branches.retrieveLoader ||
      _vm.$store.state.pos.retrieveLoader
        ? _c("VSkeleton")
        : [
            _c(
              "v-col",
              { staticClass: "px-0", staticStyle: { "z-index": "0" } },
              [
                _c("div", { staticClass: "d-flex" }, [
                  _c(
                    "div",
                    {
                      staticClass: "mr-6",
                      staticStyle: { "min-width": "400px" },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "pa-0",
                          staticStyle: { position: "fixed!important" },
                          attrs: {
                            width: "400",
                            flat: "",
                            transition: "slide-y-transition",
                            "min-height": "calc(100% - 150px)",
                          },
                        },
                        [
                          _c("VCardMapDetail", {
                            attrs: {
                              carouselList: ["", _vm.instance.photo],
                              itemList: _vm.cardMapDetail,
                              editable: _vm.editable,
                              instance: _vm.instance,
                            },
                            on: {
                              save: _vm.updateBranch,
                              "update:editable": function ($event) {
                                _vm.editable = $event
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "pb-5",
                      staticStyle: { flex: "1", "min-width": "180px" },
                    },
                    [
                      _c(
                        "v-card",
                        { staticClass: "d-none", attrs: { flat: "" } },
                        [
                          _c(
                            "v-card-text",
                            { staticClass: "px-5 py-0" },
                            [
                              _c(
                                "v-row",
                                {
                                  attrs: {
                                    justify: "center",
                                    "no-gutters": "",
                                  },
                                },
                                [
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center px-0 py-5",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "font-weight-bold body-1 grey-700--text",
                                        },
                                        [_vm._v("Estado")]
                                      ),
                                      _c(
                                        "v-sheet",
                                        {
                                          staticClass:
                                            "d-flex align-center justify-center transparent mt-8",
                                        },
                                        [
                                          _c(
                                            "div",
                                            [
                                              _c(
                                                "v-chip",
                                                {
                                                  staticClass:
                                                    "font-weight-semibold",
                                                  attrs: {
                                                    color: "blue-100",
                                                    small: "",
                                                    label: "",
                                                  },
                                                },
                                                [
                                                  _vm._v("Activo"),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        right: "",
                                                        size: "18",
                                                      },
                                                    },
                                                    [_vm._v("mdi-cloud")]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "mt-2 d-block grey-500--text body-1",
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("dateTime")(
                                                        _vm.editable.created
                                                      )
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-divider", { attrs: { vertical: "" } }),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center py-5 px-0",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "mb-4 d-block font-weight-bold body-1 grey-700--text",
                                        },
                                        [_vm._v("Porcentaje")]
                                      ),
                                      _c(
                                        "v-progress-circular",
                                        {
                                          staticClass: "progress-circular-pos",
                                          attrs: {
                                            rounded: "",
                                            rotate: 360,
                                            size: 85,
                                            width: 10,
                                            value: _vm.percent,
                                            color: "grey-900",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "d-block text-h6 grey-700--text font-weight-medium",
                                            },
                                            [_vm._v(_vm._s(_vm.posList.length))]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "pa-0 pb-3 mx-auto",
                                          attrs: { cols: "8", md: "12" },
                                        },
                                        [
                                          _c(
                                            "v-row",
                                            {
                                              staticClass:
                                                "mt-4 justify-center align-center",
                                            },
                                            [
                                              _c("v-avatar", {
                                                staticClass: "pb-1",
                                                attrs: {
                                                  size: "10",
                                                  color: "grey-900",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "ml-1 body-2",
                                                  class: `${
                                                    _vm.$vuetify.breakpoint
                                                      .width > 1200
                                                      ? "mr-4"
                                                      : "mr-1"
                                                  }`,
                                                },
                                                [_vm._v("Activos")]
                                              ),
                                              _c("v-avatar", {
                                                staticClass: "pb-1",
                                                attrs: {
                                                  size: "10",
                                                  color:
                                                    "var(--light-blue-100)",
                                                },
                                              }),
                                              _c(
                                                "span",
                                                { staticClass: "ml-1 body-2" },
                                                [_vm._v("Inactivos")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("v-divider", { attrs: { vertical: "" } }),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center py-5 px-0",
                                      attrs: { cols: "4" },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "font-weight-bold body-1 grey-700--text mx-auto",
                                        },
                                        [_vm._v("Cantidad de DTEs")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "d-block mt-6 grey-500--text body-1",
                                        },
                                        [
                                          _vm._v("$ 5.000 "),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "grey-300--text caption ml-1",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(_vm.$t("generals.CLP"))
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "mx-auto",
                                          style: `width:${
                                            _vm.$vuetify.breakpoint.width < 1260
                                              ? "160px"
                                              : "240px"
                                          }`,
                                        },
                                        [
                                          _c("chart-line", {
                                            staticClass: "d-block mx-6",
                                            staticStyle: {
                                              position: "relative",
                                            },
                                            attrs: {
                                              "axe-type-y": "number",
                                              "background-color": "transparent",
                                              colors: ["#223AF8"],
                                              "chart-data": _vm.chartLineData,
                                              "custom-labels": ["Total mes"],
                                              height: 80,
                                              "number-rounded": true,
                                              "show-axe-x": false,
                                              "show-draw-border-grid-lines-axe-y": false,
                                              "show-grid-lines-axe-y": false,
                                              "show-point": true,
                                              borderWidth: 1,
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.$helpers.hasSomePermission(["view_pos"])
                        ? _c(
                            "v-expansion-panels",
                            {
                              staticClass: "mb-5",
                              model: {
                                value: _vm.panelPos,
                                callback: function ($$v) {
                                  _vm.panelPos = $$v
                                },
                                expression: "panelPos",
                              },
                            },
                            [
                              _c(
                                "v-expansion-panel",
                                [
                                  _c(
                                    "v-expansion-panel-header",
                                    { staticClass: "px-4 py-3" },
                                    [
                                      _c(
                                        "v-row",
                                        {
                                          attrs: {
                                            "no-gutters": "",
                                            align: "center",
                                            justify: "space-between",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    size: "18",
                                                    left: "",
                                                    color: "grey-700",
                                                  },
                                                },
                                                [_vm._v("mdi-printer-pos")]
                                              ),
                                              _vm._v("POS"),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-expansion-panel-content",
                                    { staticClass: "px-0" },
                                    [
                                      _c("v-divider"),
                                      _vm.$store.state.pos.retrieveLoader
                                        ? _c("skeleton-list")
                                        : [
                                            !_vm.posList.length
                                              ? _c("v-empty-state", {
                                                  staticClass: "mt-6",
                                                  attrs: {
                                                    type: "documents",
                                                    id: "documentos",
                                                    isFree: true,
                                                    title:
                                                      "Aún no existen documentos",
                                                    customClass: "mt-1",
                                                    height: 109,
                                                    "min-height": "150",
                                                  },
                                                })
                                              : _c(
                                                  "v-col",
                                                  { staticClass: "pa-0" },
                                                  [
                                                    _c("v-simple-table", {
                                                      staticClass:
                                                        "no-hover pt-0 pb-1 px-2 table-not-rounded",
                                                      attrs: {
                                                        dense: "",
                                                        "fixed-header": "",
                                                        height:
                                                          _vm.posList.length >
                                                          12
                                                            ? "600px"
                                                            : "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "default",
                                                            fn: function () {
                                                              return [
                                                                _c(
                                                                  "thead",
                                                                  [
                                                                    _c("tr", [
                                                                      _c(
                                                                        "th",
                                                                        {
                                                                          staticClass:
                                                                            "text-left grey-700--text font-weight-medium",
                                                                          staticStyle:
                                                                            {
                                                                              "min-width":
                                                                                "200px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "ID"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "th",
                                                                        {
                                                                          staticClass:
                                                                            "text-left grey-700--text font-weight-medium",
                                                                          staticStyle:
                                                                            {
                                                                              "min-width":
                                                                                "220px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Nombre"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _c(
                                                                        "th",
                                                                        {
                                                                          staticClass:
                                                                            "text-left grey-700--text font-weight-medium",
                                                                          staticStyle:
                                                                            {
                                                                              "min-width":
                                                                                "70px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "Estado"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]),
                                                                    _c(
                                                                      "v-divider",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            position:
                                                                              "absolute",
                                                                            "z-index":
                                                                              "10",
                                                                            "margin-top":
                                                                              "-6px",
                                                                            "min-width":
                                                                              "100%",
                                                                            "margin-left":
                                                                              "-8px",
                                                                          },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "tbody",
                                                                  _vm._l(
                                                                    _vm.posList,
                                                                    function (
                                                                      item
                                                                    ) {
                                                                      return _c(
                                                                        "tr",
                                                                        {
                                                                          key: item.id,
                                                                          staticStyle:
                                                                            {
                                                                              cursor:
                                                                                "pointer",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.goToPos(
                                                                                  item.cpos_id
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "td",
                                                                            {
                                                                              staticClass:
                                                                                "text-left body-2",
                                                                              staticStyle:
                                                                                {
                                                                                  "min-width":
                                                                                    "180px",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "d-inline-block text-truncate",
                                                                                  staticStyle:
                                                                                    {
                                                                                      "max-width":
                                                                                        "100%",
                                                                                    },
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    _vm._s(
                                                                                      item.cpos_id
                                                                                    )
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "td",
                                                                            {
                                                                              staticClass:
                                                                                "body-2",
                                                                            },
                                                                            [
                                                                              item.name
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "d-inline-block text-truncate ml-n1",
                                                                                      staticStyle:
                                                                                        {
                                                                                          "max-width":
                                                                                            "100%",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          item.name
                                                                                        )
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "body-2 text--disabled font-italic",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "Sin especificar"
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                            ]
                                                                          ),
                                                                          _c(
                                                                            "td",
                                                                            {
                                                                              staticClass:
                                                                                "text-left",
                                                                            },
                                                                            [
                                                                              item
                                                                                ? _c(
                                                                                    "v-chip",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          color:
                                                                                            item.active
                                                                                              ? "blue-100"
                                                                                              : "",
                                                                                          small:
                                                                                            "",
                                                                                          label:
                                                                                            "",
                                                                                        },
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        _vm._s(
                                                                                          item.active
                                                                                            ? "Activo"
                                                                                            : "Inactivo"
                                                                                        )
                                                                                      ),
                                                                                      _c(
                                                                                        "v-icon",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              right:
                                                                                                "",
                                                                                              size: "18",
                                                                                            },
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "mdi-cloud" +
                                                                                              _vm._s(
                                                                                                item.active
                                                                                                  ? ""
                                                                                                  : "-off"
                                                                                              )
                                                                                          ),
                                                                                        ]
                                                                                      ),
                                                                                    ],
                                                                                    1
                                                                                  )
                                                                                : _vm._e(),
                                                                            ],
                                                                            1
                                                                          ),
                                                                        ]
                                                                      )
                                                                    }
                                                                  ),
                                                                  0
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        false,
                                                        1310139600
                                                      ),
                                                    }),
                                                    _c("v-divider"),
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "px-8 py-4",
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-col",
                                                          {
                                                            staticClass:
                                                              "grey-300--text body-2 px-0",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Cantidad: " +
                                                                _vm._s(
                                                                  _vm.$fmt.integer(
                                                                    _vm.posList
                                                                      .length
                                                                  )
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                          ],
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-expansion-panels",
                        {
                          staticClass: "mt-5",
                          model: {
                            value: _vm.panelNumering,
                            callback: function ($$v) {
                              _vm.panelNumering = $$v
                            },
                            expression: "panelNumering",
                          },
                        },
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                { staticClass: "px-4 py-3" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        "no-gutters": "",
                                        align: "center",
                                        justify: "space-between",
                                      },
                                    },
                                    [
                                      _c("v-col", { attrs: { cols: "4" } }, [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "subtitle-2 grey-700--text font-weight-bold text-capitalize d-flex align-center",
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              {
                                                attrs: {
                                                  size: "18",
                                                  left: "",
                                                  color: "grey-700",
                                                },
                                              },
                                              [_vm._v("mdi-file-document")]
                                            ),
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("generals.Numeración")
                                              )
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _c("v-spacer"),
                                      _c(
                                        "v-col",
                                        {
                                          staticClass: "text-right",
                                          class:
                                            _vm.panelNumering === 0
                                              ? "mr-4"
                                              : "mr-3",
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: { outlined: "" },
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  _vm.cafDialog = true
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { left: "" } },
                                                [_vm._v("mdi-file-plus ")]
                                              ),
                                              _vm._v("Agregar "),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { staticClass: "px-0" },
                                [
                                  _c("v-divider"),
                                  _c(
                                    "v-tabs",
                                    {
                                      staticClass: "mt-n1",
                                      attrs: {
                                        color: "grey-900",
                                        grow: "",
                                        height: "46",
                                        "slider-size": "3",
                                      },
                                      model: {
                                        value: _vm.numeringTab,
                                        callback: function ($$v) {
                                          _vm.numeringTab = $$v
                                        },
                                        expression: "numeringTab",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-tab",
                                        {
                                          staticClass:
                                            "body-2 grey-700--text basic-tab",
                                          attrs: { exact: "", ripple: false },
                                        },
                                        [_vm._v("Activos")]
                                      ),
                                      _c(
                                        "v-tab",
                                        {
                                          staticClass:
                                            "body-2 grey-700--text basic-tab",
                                          attrs: { exact: "", ripple: false },
                                        },
                                        [_vm._v("Usados")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.numberingList?.length
                                    ? [
                                        _c("v-data-table", {
                                          staticClass: "table-not-rounded",
                                          attrs: {
                                            headers: _vm.currentHeader,
                                            items: _vm.numberingList,
                                            "hide-default-header": "",
                                            "disable-sort": "",
                                            "hide-default-footer": "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "header",
                                                fn: function ({
                                                  props: { headers },
                                                }) {
                                                  return [
                                                    _c("VTableHeaders", {
                                                      attrs: {
                                                        headers: headers,
                                                        sortable: false,
                                                      },
                                                    }),
                                                    _c("v-divider", {
                                                      staticStyle: {
                                                        "min-width": "100%",
                                                        position: "absolute",
                                                        "margin-top": "-6px",
                                                        "margin-left": "-5px",
                                                      },
                                                    }),
                                                  ]
                                                },
                                              },
                                              {
                                                key: `item.document_type`,
                                                fn: function ({ item }) {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "nameDocumentsType"
                                                          )(item.document_type)
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                              },
                                              {
                                                key: `item.restantes`,
                                                fn: function ({ item }) {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.end -
                                                            item.current +
                                                            1
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                              },
                                              {
                                                key: `item.created`,
                                                fn: function ({ item }) {
                                                  return [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("date")(
                                                            item.created
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    : _c("v-empty-state", {
                                        staticClass: "mt-6",
                                        attrs: {
                                          type: "documents",
                                          id: "documentos",
                                          isFree: true,
                                          title: `Aún no existe ${_vm.$t(
                                            "generals.numeración"
                                          )}`,
                                          customClass: "mt-1",
                                          height: 109,
                                          "min-height": "150",
                                          hiddenDescription: false,
                                        },
                                      }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-expansion-panels",
                        {
                          staticClass: "mt-5",
                          model: {
                            value: _vm.panelDocuments,
                            callback: function ($$v) {
                              _vm.panelDocuments = $$v
                            },
                            expression: "panelDocuments",
                          },
                        },
                        [
                          _c(
                            "v-expansion-panel",
                            [
                              _c(
                                "v-expansion-panel-header",
                                { staticClass: "px-4 py-3" },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      attrs: {
                                        "no-gutters": "",
                                        align: "center",
                                        justify: "space-between",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "subtitle-2 grey-700--text font-weight-bold d-flex align-center",
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                size: "18",
                                                left: "",
                                                color: "grey-700",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "mdi-file-document-multiple"
                                              ),
                                            ]
                                          ),
                                          _vm._v("Documentos emitidos"),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-expansion-panel-content",
                                { staticClass: "px-0" },
                                [
                                  _c("v-divider"),
                                  !_vm.loading
                                    ? [
                                        !_vm.documentsList.length
                                          ? _c("v-empty-state", {
                                              staticClass: "mt-6",
                                              attrs: {
                                                type: "documents",
                                                id: "documentos",
                                                isFree: true,
                                                title: `Aún no existen documentos`,
                                                customClass: "mt-1",
                                                height: 109,
                                                "min-height": "150",
                                              },
                                            })
                                          : [
                                              _c("documents-list", {
                                                attrs: {
                                                  showPagination: false,
                                                },
                                              }),
                                              _vm.count && !_vm.loading
                                                ? [
                                                    _c("v-divider"),
                                                    _c(
                                                      "v-row",
                                                      {
                                                        staticClass:
                                                          "px-8 py-4",
                                                        attrs: {
                                                          align: "center",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            staticClass:
                                                              "body-1",
                                                            attrs: {
                                                              to: {
                                                                name: "DocumentsList",
                                                                params:
                                                                  _vm.currentParams,
                                                                query: {
                                                                  branch_id:
                                                                    _vm.instance
                                                                      .branch_id,
                                                                },
                                                              },
                                                              ripple: false,
                                                              text: "",
                                                              color: "grey-900",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Ver todos los documentos"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : _vm._e(),
                                            ],
                                      ]
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ],
      _c(
        "v-dialog",
        {
          attrs: {
            width: "835",
            persistent: "",
            "no-click-animation": "",
            scrollable: "",
            "overlay-color": "grey-500",
          },
          model: {
            value: _vm.dialogBranch,
            callback: function ($$v) {
              _vm.dialogBranch = $$v
            },
            expression: "dialogBranch",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-toolbar",
                    {
                      staticClass: "transparent",
                      attrs: { flat: "", height: "46" },
                    },
                    [
                      _c(
                        "v-toolbar-title",
                        {
                          staticClass:
                            "px-5 subtitle-2 grey-700--text font-weight-semibold",
                        },
                        [_vm._v("Editar tienda")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-toolbar-items",
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "mr-3",
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: { icon: "", small: "" },
                                  on: { click: _vm.handleModal },
                                },
                                [
                                  _c("v-icon", { attrs: { size: "20" } }, [
                                    _vm._v("mdi-close"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                { staticClass: "px-5 py-4" },
                [
                  _c(
                    "v-row",
                    { staticClass: "pt-2 pb-2", attrs: { align: "center" } },
                    [
                      _c("v-col", { attrs: { cols: "3" } }, [
                        _c("img", {
                          attrs: {
                            src: require(`@/assets/backgrounds/background-branch-detail.svg`),
                            height: 128,
                          },
                        }),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "pr-4 pl-4" },
                        [
                          _c(
                            "v-list",
                            {
                              staticClass:
                                "v-list-form-extended pa-0 transparent",
                            },
                            [
                              _c(
                                "v-list-item",
                                { staticClass: "py-0" },
                                [
                                  _c("v-list-item-title", [_vm._v("Nombre")]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          error:
                                            _vm.$v.editable.custom_id.$error,
                                          outlined: "",
                                          required: "",
                                          "single-line": "",
                                          dense: "",
                                          maxlength: "100",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value:
                                            _vm.$v.editable.custom_id.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.editable.custom_id,
                                              "$model",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "$v.editable.custom_id.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "py-2" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v("Dirección"),
                                  ]),
                                  _c(
                                    "v-list-item-subtitle",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          error: _vm.$v.editable.address.$error,
                                          outlined: "",
                                          required: "",
                                          "single-line": "",
                                          dense: "",
                                          maxlength: "64",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.$v.editable.address.$model,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.$v.editable.address,
                                              "$model",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression:
                                            "$v.editable.address.$model",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                { staticClass: "py-0" },
                                [
                                  _c("v-list-item-title", [
                                    _vm._v(_vm._s(_vm.$t("generals.Comuna"))),
                                  ]),
                                  _vm.$store.getters["base/currentStates"]
                                    ? _c(
                                        "v-list-item-subtitle",
                                        [
                                          _c("v-autocomplete", {
                                            attrs: {
                                              "append-icon": "mdi-chevron-down",
                                              label: _vm.$t("generals.Comuna"),
                                              items:
                                                _vm.$store.getters[
                                                  "base/currentStates"
                                                ] || [],
                                              "item-value": "id",
                                              "item-text": "name",
                                              "single-line": "",
                                              "hide-details": "",
                                              dense: "",
                                              height: "30",
                                              outlined: "",
                                              "no-data-text":
                                                "No existen estados para el país.",
                                            },
                                            model: {
                                              value: _vm.editable.state,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editable,
                                                  "state",
                                                  $$v
                                                )
                                              },
                                              expression: "editable.state",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                { staticClass: "px-5 py-2" },
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    { attrs: { outlined: "" }, on: { click: _vm.handleModal } },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "grey-900",
                        disabled: _vm.isDisabledButton,
                      },
                      on: { click: _vm.updateBranch },
                    },
                    [_vm._v("Guardar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("VUpload", {
        attrs: { cafDialog: _vm.cafDialog },
        on: {
          "update:cafDialog": function ($event) {
            _vm.cafDialog = $event
          },
          "update:caf-dialog": function ($event) {
            _vm.cafDialog = $event
          },
          getList: function ($event) {
            return _vm.getNumbering(_vm.numeringTab)
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }